import React from 'react';

import { RCCallout } from '@reverbdotcom/cadence/components';
import { I18N } from '@reverbdotcom/commons/src/components/translate';

import { USPS_SLUG, UPS_SUREPOST_SLUG } from './time_to_ship_module_one';

const CARRIERS_WITH_CALLOUTS = [USPS_SLUG, UPS_SUREPOST_SLUG];

export default function OrderDetailsCarrierCallout({ carrier }: { carrier: string; }) {
  if (!CARRIERS_WITH_CALLOUTS.includes(carrier)) return null;

  return (
    <RCCallout
      themeType="utility"
      variant="notice-ultralight"
      border="thin"
    >
      <I18N
        html
        text={`discovery.selling.order.orderDetailsCarrierCallouts.${carrier}Html`}
      />
    </RCCallout>
  );
}
